<script setup lang="ts">
import { getLangText } from '@/ts/utils/utils.ts';
import LiveCasinoIcon from "./assets/live-casino.svg?raw";
import { navigateTo } from '@/ts/management/view-navigation-management';
import model from '@/ts/model';
import { isNavViewItemActive } from './mobile-nav-bottom';
</script>

<template>
    <div class="nav-item" @click.prevent.stop="navigateTo('live-casino')" :class="{active: isNavViewItemActive('live-casino')}">
        <div class="icon">
            <span v-html="LiveCasinoIcon"></span>
        </div>
        <div class="name">{{ getLangText('LiveCasinoShort', undefined, 'mobile-nav-bottom') }}</div>
    </div>
</template>

<style lang="scss" scoped>
@use './nav-item.scss';
</style>